// Comprehensive Food Database with Macro and Micronutrients
export const defaultFoods = [
  // PROTEINS
  {
    id: 1,
    name: 'Chicken Breast',
    category: 'protein',
    servingSize: '6 oz (170g)',
    calories: 280,
    protein: 52,
    carbs: 0,
    fat: 6,
    fiber: 0,
    sugar: 0,
    saturatedFat: 2,
    transFat: 0,
    monounsaturatedFat: 2,
    polyunsaturatedFat: 1,
    omega3: 50,
    omega6: 200,
    cholesterol: 85,
    sodium: 75,
    potassium: 350,
    calcium: 15,
    iron: 1.3,
    magnesium: 35,
    phosphorus: 220,
    zinc: 1.0,
    copper: 0.08,
    manganese: 0.02,
    selenium: 27,
    vitaminA: 0,
    vitaminB12: 0.3,
    vitaminC: 0,
    vitaminD: 0,
    vitaminE: 0.3,
    vitaminK: 0,
    folate: 3,
    niacin: 10.3,
  },
  {
    id: 2,
    name: 'Salmon Fillet',
    category: 'protein',
    servingSize: '6 oz (170g)',
    calories: 360,
    protein: 42,
    carbs: 0,
    fat: 20,
    fiber: 0,
    sugar: 0,
    saturatedFat: 4,
    transFat: 0,
    monounsaturatedFat: 8,
    polyunsaturatedFat: 7,
    omega3: 2500,
    omega6: 800,
    cholesterol: 78,
    sodium: 75,
    potassium: 490,
    calcium: 25,
    iron: 0.8,
    magnesium: 40,
    phosphorus: 350,
    zinc: 0.8,
    copper: 0.1,
    manganese: 0.02,
    selenium: 36,
    vitaminA: 180,
    vitaminB12: 3.2,
    vitaminC: 0,
    vitaminD: 570,
    vitaminE: 2.3,
    vitaminK: 0,
    folate: 30,
    niacin: 8.5,
  },
  {
    id: 3,
    name: 'Eggs (Large)',
    category: 'protein',
    servingSize: '1 large egg',
    calories: 78,
    protein: 6,
    carbs: 0.6,
    fat: 5.3,
    fiber: 0,
    sugar: 0.6,
    saturatedFat: 1.6,
    transFat: 0,
    monounsaturatedFat: 2.0,
    polyunsaturatedFat: 0.7,
    omega3: 37,
    omega6: 470,
    cholesterol: 186,
    sodium: 71,
    potassium: 69,
    calcium: 28,
    iron: 0.9,
    magnesium: 6,
    phosphorus: 99,
    zinc: 0.6,
    copper: 0.04,
    manganese: 0.03,
    selenium: 15,
    vitaminA: 270,
    vitaminB12: 0.6,
    vitaminC: 0,
    vitaminD: 87,
    vitaminE: 0.6,
    vitaminK: 0.3,
    folate: 47,
    niacin: 0.04,
  },
  {
    id: 4,
    name: 'Turkey Breast',
    category: 'protein',
    servingSize: '4 oz (113g)',
    calories: 180,
    protein: 35,
    carbs: 0,
    fat: 3.5,
    fiber: 0,
    sugar: 0,
    saturatedFat: 1.1,
    transFat: 0,
    monounsaturatedFat: 0.8,
    polyunsaturatedFat: 0.8,
    omega3: 30,
    omega6: 150,
    cholesterol: 65,
    sodium: 54,
    potassium: 280,
    calcium: 12,
    iron: 1.3,
    magnesium: 28,
    phosphorus: 210,
    zinc: 2.4,
    copper: 0.06,
    manganese: 0.02,
    selenium: 32,
    vitaminA: 0,
    vitaminB12: 0.3,
    vitaminC: 0,
    vitaminD: 0,
    vitaminE: 0.2,
    vitaminK: 0,
    folate: 2,
    niacin: 5.1,
  },
  {
    id: 5,
    name: 'Lean Beef',
    category: 'protein',
    servingSize: '5 oz (142g)',
    calories: 280,
    protein: 45,
    carbs: 0,
    fat: 11,
    fiber: 0,
    sugar: 0,
    saturatedFat: 4.5,
    transFat: 0.3,
    monounsaturatedFat: 4.5,
    polyunsaturatedFat: 0.5,
    omega3: 50,
    omega6: 200,
    cholesterol: 95,
    sodium: 75,
    potassium: 380,
    calcium: 20,
    iron: 2.6,
    magnesium: 30,
    phosphorus: 280,
    zinc: 7.5,
    copper: 0.1,
    manganese: 0.02,
    selenium: 33,
    vitaminA: 0,
    vitaminB12: 2.4,
    vitaminC: 0,
    vitaminD: 0,
    vitaminE: 0.3,
    vitaminK: 0,
    folate: 5,
    niacin: 6.5,
  },
  {
    id: 6,
    name: 'Greek Yogurt',
    category: 'dairy',
    servingSize: '1 cup (227g)',
    calories: 220,
    protein: 22,
    carbs: 9,
    fat: 5,
    fiber: 0,
    sugar: 7,
    saturatedFat: 3,
    transFat: 0,
    monounsaturatedFat: 1.3,
    polyunsaturatedFat: 0.2,
    omega3: 30,
    omega6: 100,
    cholesterol: 20,
    sodium: 75,
    potassium: 240,
    calcium: 200,
    iron: 0.2,
    magnesium: 20,
    phosphorus: 180,
    zinc: 1.2,
    copper: 0.05,
    manganese: 0.01,
    selenium: 8,
    vitaminA: 50,
    vitaminB12: 1.3,
    vitaminC: 2,
    vitaminD: 0,
    vitaminE: 0.1,
    vitaminK: 0.1,
    folate: 24,
    niacin: 0.3,
  },
];

export const foodCategories = [
  { value: 'protein', label: 'Protein' },
  { value: 'carbs', label: 'Carbs' },
  { value: 'fat', label: 'Fat' },
  { value: 'vegetable', label: 'Vegetable' },
  { value: 'fruit', label: 'Fruit' },
  { value: 'dairy', label: 'Dairy' },
  { value: 'grain', label: 'Grain' },
  { value: 'legume', label: 'Legume' },
  { value: 'nut', label: 'Nut & Seed' },
  { value: 'oil', label: 'Oil & Condiment' },
  { value: 'supplement', label: 'Supplement' },
];

// CARBS
export const carbFoods = [
  {
    id: 101,
    name: 'Oatmeal',
    category: 'carbs',
    servingSize: '1 cup cooked (150g)',
    calories: 150,
    protein: 5,
    carbs: 27,
    fat: 3,
    fiber: 4,
    sugar: 1,
    saturatedFat: 0.5,
    transFat: 0,
    monounsaturatedFat: 0.9,
    polyunsaturatedFat: 1.1,
    omega3: 50,
    omega6: 800,
    cholesterol: 0,
    sodium: 2,
    potassium: 150,
    calcium: 42,
    iron: 2.1,
    magnesium: 44,
    phosphorus: 150,
    zinc: 1.4,
    copper: 0.12,
    manganese: 0.76,
    selenium: 7,
    vitaminA: 0,
    vitaminB12: 0,
    vitaminC: 0,
    vitaminD: 0,
    vitaminE: 0.1,
    vitaminK: 0,
    folate: 11,
    niacin: 0.7,
  },
  {
    id: 102,
    name: 'Brown Rice',
    category: 'carbs',
    servingSize: '1 cup cooked (195g)',
    calories: 215,
    protein: 5,
    carbs: 45,
    fat: 1.8,
    fiber: 3.5,
    sugar: 0.7,
    saturatedFat: 0.4,
    transFat: 0,
    monounsaturatedFat: 0.6,
    polyunsaturatedFat: 0.6,
    omega3: 20,
    omega6: 400,
    cholesterol: 0,
    sodium: 10,
    potassium: 150,
    calcium: 20,
    iron: 0.8,
    magnesium: 84,
    phosphorus: 150,
    zinc: 1.2,
    copper: 0.1,
    manganese: 1.8,
    selenium: 19,
    vitaminA: 0,
    vitaminB12: 0,
    vitaminC: 0,
    vitaminD: 0,
    vitaminE: 0.2,
    vitaminK: 0,
    folate: 8,
    niacin: 3.0,
  },
  {
    id: 103,
    name: 'Quinoa',
    category: 'carbs',
    servingSize: '1 cup cooked (185g)',
    calories: 222,
    protein: 8,
    carbs: 39,
    fat: 4,
    fiber: 5,
    sugar: 1.6,
    saturatedFat: 0.4,
    transFat: 0,
    monounsaturatedFat: 1.2,
    polyunsaturatedFat: 1.6,
    omega3: 300,
    omega6: 1500,
    cholesterol: 0,
    sodium: 8,
    potassium: 281,
    calcium: 19,
    iron: 2.8,
    magnesium: 118,
    phosphorus: 281,
    zinc: 1.2,
    copper: 0.2,
    manganese: 0.6,
    selenium: 2.7,
    vitaminA: 0,
    vitaminB12: 0,
    vitaminC: 1.5,
    vitaminD: 0,
    vitaminE: 0.6,
    vitaminK: 0,
    folate: 78,
    niacin: 0.4,
  },
  {
    id: 104,
    name: 'Sweet Potato',
    category: 'carbs',
    servingSize: '1 medium (103g)',
    calories: 103,
    protein: 2,
    carbs: 24,
    fat: 0.1,
    fiber: 3.9,
    sugar: 5.5,
    saturatedFat: 0.03,
    transFat: 0,
    monounsaturatedFat: 0.01,
    polyunsaturatedFat: 0.04,
    omega3: 10,
    omega6: 30,
    cholesterol: 0,
    sodium: 55,
    potassium: 337,
    calcium: 30,
    iron: 0.7,
    magnesium: 25,
    phosphorus: 47,
    zinc: 0.3,
    copper: 0.15,
    manganese: 0.26,
    selenium: 0.6,
    vitaminA: 961,
    vitaminB12: 0,
    vitaminC: 8.8,
    vitaminD: 0,
    vitaminE: 0.7,
    vitaminK: 1.9,
    folate: 6,
    niacin: 0.6,
  },
  {
    id: 105,
    name: 'Whole Wheat Bread',
    category: 'carbs',
    servingSize: '1 slice (28g)',
    calories: 80,
    protein: 4,
    carbs: 14,
    fat: 1,
    fiber: 2.4,
    sugar: 1,
    saturatedFat: 0.2,
    transFat: 0,
    monounsaturatedFat: 0.2,
    polyunsaturatedFat: 0.4,
    omega3: 30,
    omega6: 200,
    cholesterol: 0,
    sodium: 140,
    potassium: 90,
    calcium: 20,
    iron: 1.0,
    magnesium: 24,
    phosphorus: 86,
    zinc: 0.7,
    copper: 0.1,
    manganese: 0.5,
    selenium: 8,
    vitaminA: 0,
    vitaminB12: 0,
    vitaminC: 0,
    vitaminD: 0,
    vitaminE: 0.1,
    vitaminK: 0,
    folate: 27,
    niacin: 1.5,
  },
];

// VEGETABLES
export const vegetableFoods = [
  {
    id: 201,
    name: 'Broccoli',
    category: 'vegetable',
    servingSize: '2 cups (178g)',
    calories: 55,
    protein: 3.7,
    carbs: 11,
    fat: 0.6,
    fiber: 2.4,
    sugar: 2.2,
    saturatedFat: 0.1,
    transFat: 0,
    monounsaturatedFat: 0.1,
    polyunsaturatedFat: 0.3,
    omega3: 100,
    omega6: 150,
    cholesterol: 0,
    sodium: 64,
    potassium: 540,
    calcium: 71,
    iron: 1.0,
    magnesium: 21,
    phosphorus: 66,
    zinc: 0.6,
    copper: 0.08,
    manganese: 0.2,
    selenium: 2.6,
    vitaminA: 623,
    vitaminB12: 0,
    vitaminC: 135,
    vitaminD: 0,
    vitaminE: 1.5,
    vitaminK: 220,
    folate: 63,
    niacin: 0.6,
  },
  {
    id: 202,
    name: 'Bell Peppers',
    category: 'vegetable',
    servingSize: '2 cups (300g)',
    calories: 60,
    protein: 2,
    carbs: 14,
    fat: 0.3,
    fiber: 2.5,
    sugar: 9,
    saturatedFat: 0.05,
    transFat: 0,
    monounsaturatedFat: 0.05,
    polyunsaturatedFat: 0.15,
    omega3: 20,
    omega6: 100,
    cholesterol: 0,
    sodium: 6,
    potassium: 600,
    calcium: 30,
    iron: 0.6,
    magnesium: 24,
    phosphorus: 48,
    zinc: 0.3,
    copper: 0.1,
    manganese: 0.2,
    selenium: 0.6,
    vitaminA: 1200,
    vitaminB12: 0,
    vitaminC: 300,
    vitaminD: 0,
    vitaminE: 3.6,
    vitaminK: 14,
    folate: 72,
    niacin: 1.2,
  },
  {
    id: 203,
    name: 'Asparagus',
    category: 'vegetable',
    servingSize: '1 bunch (300g)',
    calories: 81,
    protein: 8.8,
    carbs: 15,
    fat: 0.2,
    fiber: 2.8,
    sugar: 1.9,
    saturatedFat: 0.05,
    transFat: 0,
    monounsaturatedFat: 0.05,
    polyunsaturatedFat: 0.1,
    omega3: 50,
    omega6: 100,
    cholesterol: 0,
    sodium: 3,
    potassium: 912,
    calcium: 36,
    iron: 2.7,
    magnesium: 19,
    phosphorus: 66,
    zinc: 0.5,
    copper: 0.18,
    manganese: 0.2,
    selenium: 4.0,
    vitaminA: 1080,
    vitaminB12: 0,
    vitaminC: 20,
    vitaminD: 0,
    vitaminE: 1.5,
    vitaminK: 145,
    folate: 262,
    niacin: 1.9,
  },
];

// FRUITS
export const fruitFoods = [
  {
    id: 301,
    name: 'Banana',
    category: 'fruit',
    servingSize: '1 medium (118g)',
    calories: 105,
    protein: 1.3,
    carbs: 27,
    fat: 0.3,
    fiber: 3.1,
    sugar: 14,
    saturatedFat: 0.1,
    transFat: 0,
    monounsaturatedFat: 0.03,
    polyunsaturatedFat: 0.1,
    omega3: 30,
    omega6: 60,
    cholesterol: 0,
    sodium: 1,
    potassium: 422,
    calcium: 5,
    iron: 0.3,
    magnesium: 27,
    phosphorus: 22,
    zinc: 0.2,
    copper: 0.1,
    manganese: 0.3,
    selenium: 1.2,
    vitaminA: 3,
    vitaminB12: 0,
    vitaminC: 8.7,
    vitaminD: 0,
    vitaminE: 0.1,
    vitaminK: 0.5,
    folate: 20,
    niacin: 0.7,
  },
  {
    id: 302,
    name: 'Blueberries',
    category: 'fruit',
    servingSize: '1 cup (148g)',
    calories: 84,
    protein: 1.1,
    carbs: 21,
    fat: 0.5,
    fiber: 3.6,
    sugar: 15,
    saturatedFat: 0.04,
    transFat: 0,
    monounsaturatedFat: 0.1,
    polyunsaturatedFat: 0.2,
    omega3: 100,
    omega6: 200,
    cholesterol: 0,
    sodium: 1.5,
    potassium: 148,
    calcium: 9,
    iron: 0.3,
    magnesium: 9,
    phosphorus: 18,
    zinc: 0.2,
    copper: 0.1,
    manganese: 0.3,
    selenium: 0.6,
    vitaminA: 80,
    vitaminB12: 0,
    vitaminC: 9.7,
    vitaminD: 0,
    vitaminE: 0.6,
    vitaminK: 29,
    folate: 6,
    niacin: 0.4,
  },
  {
    id: 303,
    name: 'Apple',
    category: 'fruit',
    servingSize: '1 medium (182g)',
    calories: 95,
    protein: 0.5,
    carbs: 25,
    fat: 0.3,
    fiber: 4.4,
    sugar: 19,
    saturatedFat: 0.05,
    transFat: 0,
    monounsaturatedFat: 0.01,
    polyunsaturatedFat: 0.09,
    omega3: 10,
    omega6: 50,
    cholesterol: 0,
    sodium: 2,
    potassium: 195,
    calcium: 11,
    iron: 0.2,
    magnesium: 5,
    phosphorus: 11,
    zinc: 0.04,
    copper: 0.03,
    manganese: 0.04,
    selenium: 0,
    vitaminA: 5,
    vitaminB12: 0,
    vitaminC: 5.7,
    vitaminD: 0,
    vitaminE: 0.4,
    vitaminK: 4,
    folate: 3,
    niacin: 0.1,
  },
];

// NUTS & SEEDS
export const nutFoods = [
  {
    id: 401,
    name: 'Almonds',
    category: 'nut',
    servingSize: '1/4 cup (28g)',
    calories: 164,
    protein: 6,
    carbs: 6,
    fat: 14,
    fiber: 3.5,
    sugar: 1.2,
    saturatedFat: 1.1,
    transFat: 0,
    monounsaturatedFat: 8.8,
    polyunsaturatedFat: 3.5,
    omega3: 0,
    omega6: 3500,
    cholesterol: 0,
    sodium: 0.3,
    potassium: 208,
    calcium: 76,
    iron: 1.3,
    magnesium: 76,
    phosphorus: 136,
    zinc: 0.9,
    copper: 0.3,
    manganese: 0.6,
    selenium: 1.2,
    vitaminA: 0,
    vitaminB12: 0,
    vitaminC: 0,
    vitaminD: 0,
    vitaminE: 11.6,
    vitaminK: 0,
    folate: 14,
    niacin: 1.1,
  },
];

// OILS & CONDIMENTS
export const oilFoods = [
  {
    id: 501,
    name: 'Olive Oil',
    category: 'oil',
    servingSize: '1.5 tbsp (21g)',
    calories: 189,
    protein: 0,
    carbs: 0,
    fat: 21,
    fiber: 0,
    sugar: 0,
    saturatedFat: 2.9,
    transFat: 0,
    monounsaturatedFat: 15.3,
    polyunsaturatedFat: 1.8,
    omega3: 100,
    omega6: 1200,
    cholesterol: 0,
    sodium: 0.3,
    potassium: 0,
    calcium: 0,
    iron: 0,
    magnesium: 0,
    phosphorus: 0,
    zinc: 0,
    copper: 0,
    manganese: 0,
    selenium: 0,
    vitaminA: 0,
    vitaminB12: 0,
    vitaminC: 0,
    vitaminD: 0,
    vitaminE: 1.9,
    vitaminK: 8.1,
    folate: 0,
    niacin: 0,
  },
];
